export const REQUEST_OTP_INITIATED = 'REQUEST_OTP_INITIATED';
export const REQUEST_OTP_SUCCEEDED = 'REQUEST_OTP_SUCCEEDED';
export const REQUEST_OTP_FAILED = 'REQUEST_OTP_FAILED';
